// extracted by mini-css-extract-plugin
module.exports = {"content":"ConfirmView_content__1Kh1y","contentText":"ConfirmView_contentText__DuztO","link":"ConfirmView_link__16w8R","mail":"ConfirmView_mail__1UDHK"};